import { StateCode } from '@/types/schema';

export const exemptionNotApplicableStates = [StateCode.Il, StateCode.Ny];

export function getStateTaxTooltipContent(state: StateCode) {
  if (state === StateCode.Ct) {
    return `Assumes the taxable estate in excess of the exemption is taxed according to the state's flat tax rate of 12%.`;
  }

  if (state === StateCode.Md || state === StateCode.Vt) {
    return `Assumes the taxable estate in excess of the exemption is taxed according to the state's flat tax rate of 16%.`;
  }

  if (exemptionNotApplicableStates.includes(state)) {
    return `Assumes the full taxable estate is taxed according to the progressive state tax brackets.`;
  }

  return `Assumes the taxable estate in excess of the exemption is taxed according to the progressive state tax brackets.`;
}
